/* istanbul ignore file */
import { FormSection } from 'framework/ui/layout';
import BaseTimelineRecordLayout from 'domain/shared/timeline/layout/BaseTimelineRecordLayout';
import { Collapsible, LinkField, TextField } from 'framework/ui/field';
import useProjectStatusesService, {
  StatusTypesLabels,
  StatusTypes,
  UPDATE_PROJECT_STATUS,
} from 'domain/projects/project/statuses/ProjectStatusesService';
import { EditTimelineRecordButton } from 'domain/shared/timeline/button';
import StatusPeriodField from '../../shared/field/StatusPeriodField';
import TicketsListField from '../../shared/field/TicketsListField';
import { useShowContext } from 'framework/show';

const StatusPlanningRecordLayout = ({ onEdit, ...props }: any) => {
  const { data: entity } = useShowContext();
  const { checkIsEditable } = useProjectStatusesService();
  const isEditable = checkIsEditable(new Date(entity.to), 7);

  const buttons = isEditable
    ? [<EditTimelineRecordButton permissionToCheck={UPDATE_PROJECT_STATUS} key="edit" onEdit={onEdit} />]
    : [];

  return (
    <BaseTimelineRecordLayout
      timelineType={StatusTypesLabels[StatusTypes.PLANNING]}
      buttons={buttons}
      fields={
        <Collapsible>
          <>
            <StatusPeriodField label="Weekly cycle period" source="from" toSource="to" />
            <LinkField source="recordLink" label="Link to the planning record" />
            <TextField source="scopeDescription" label="Scope description" />
            {entity.tickets && entity.tickets.length > 0 && (
              <FormSection title="Planned work items" titleVariant="h6">
                <TicketsListField source="tickets" label="" />
              </FormSection>
            )}
          </>
        </Collapsible>
      }
      {...props}
    />
  );
};

export default StatusPlanningRecordLayout;
